import type { ChapterCourseDifficulty } from '@jojotique/server'

String.prototype.neon = function (): string {
  const words = this.split(' ')

  const halfIndex = Math.ceil(words.length / 2)

  const firstHalf = words.slice(0, halfIndex).join(' ')
  const secondHalf = words.slice(halfIndex).join(' ')

  return `${firstHalf} <span class="neon-text-secondary">${secondHalf}</span>`
}

export const getDifficultyLabel = (difficulty: ChapterCourseDifficulty): string =>
  ({
    baby: 'Initiation au rêve (débutant)',
    medium: 'Défi protocolaire (intermédiaire)',
    hard: 'Anomalie dans la matrice (avancé)',
    hell: 'Mode Cyberpunk (expert)',
  })[difficulty]
